export default __webpack_public_path__ + "static/bg-email-automation-7ecfb557021f42f8dcab081c6885ef1d.jpg";